import { render, staticRenderFns } from "./VuesticIconFree.vue?vue&type=template&id=9d45180e"
import script from "./VuesticIconFree.vue?vue&type=script&lang=js"
export * from "./VuesticIconFree.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconFree.vue?vue&type=style&index=0&id=9d45180e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports